/**
 * Font-size preference (S / M / L) for the markdown reading area.
 * Persisted in localStorage; mirrored to a `data-font-size` attribute
 * on the `<html>` element so theme.css can pick it up.
 */

export type FontSize = 'sm' | 'md' | 'lg'

const STORAGE_KEY = 'markfy.fontSize'
const DEFAULT: FontSize = 'md'

export function readFontSize(): FontSize {
  if (typeof localStorage === 'undefined') return DEFAULT
  const stored = localStorage.getItem(STORAGE_KEY)
  if (stored === 'sm' || stored === 'md' || stored === 'lg') return stored
  return DEFAULT
}

export function writeFontSize(size: FontSize): void {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, size)
  }
  applyFontSize(size)
}

export function applyFontSize(size: FontSize): void {
  if (typeof document !== 'undefined') {
    document.documentElement.setAttribute('data-font-size', size)
  }
}
